const apiKey = 'b2b-nnF7C8DxD';
const apiBaseUrl = 'https://api.zoomos.by'; // https

module.exports = {
  apiKey,
  apiBaseUrl
};